import { PassouFalhouEnum } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { calculateResultadoPergunta14 } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-14/utils-consultaSeguimentoPergunta14'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'
import { MChatPerguntaEnum } from 'graphql/types.generated'

import { HistoricoMChatHeaderTableItem } from '../components/HistoricoMchatHeaderTableItem'
import { HistoricoMChatPerguntaSection } from '../components/HistoricoMchatPerguntaSection'
import { HistoricoMChatResultadoParcialTableItem } from '../components/HistoricoMChatResultadoParcialTableItem'
import { HistoricoMChatSimpleVerticalTableItem } from '../components/HistoricoMChatSimpleVerticalTableItem'
import { HistoricoMchatTwoColumnsEvenlyTableItem } from '../components/HistoricoMchatTwoColumnsEvenlyTableItem'
import { convertAplicacaoPergunta14 } from './converter-HistoricoMchatPergunta14'

interface HistoricoMChatRfPergunta14Props {
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
}

export const HistoricoMChatRfPergunta14 = (props: Readonly<HistoricoMChatRfPergunta14Props>) => {
  const { aplicacoes } = props

  const converted = convertAplicacaoPergunta14(aplicacoes)
  if (converted == null) return null

  const { header, deuExemploAbaixo, olhaSeusOlhos, olhaSeusOlhosTodosDias, olhaSeusOlhos5Vezes, model } = converted
  if (header === null) return null

  const resultado = calculateResultadoPergunta14(model)
  const hasOlhaSeusOlhos = olhaSeusOlhos.isNotEmpty()

  return (
    <HistoricoMChatPerguntaSection>
      <HistoricoMChatHeaderTableItem
        numeroPergunta='14'
        title={header.textoPergunta}
        value={header.stPassou}
        pergunta={undefined}
      />
      {deuExemploAbaixo && <HistoricoMchatTwoColumnsEvenlyTableItem perguntas={[deuExemploAbaixo]} />}
      <HistoricoMChatSimpleVerticalTableItem pergunta='Ele olha nos seus olhos...' resposta={undefined} />
      {deuExemploAbaixo?.stPassou === true && <HistoricoMchatTwoColumnsEvenlyTableItem perguntas={PERGUNTAS} />}
      {hasOlhaSeusOlhos && <HistoricoMchatTwoColumnsEvenlyTableItem perguntas={olhaSeusOlhos} />}
      {olhaSeusOlhosTodosDias && <HistoricoMchatTwoColumnsEvenlyTableItem perguntas={[olhaSeusOlhosTodosDias]} />}
      {olhaSeusOlhos5Vezes && <HistoricoMchatTwoColumnsEvenlyTableItem perguntas={[olhaSeusOlhos5Vezes]} />}
      {resultado && <HistoricoMChatResultadoParcialTableItem valor={resultado === PassouFalhouEnum.PASSOU} />}
    </HistoricoMChatPerguntaSection>
  )
}

const PERGUNTAS: MchatRfAplicacaoQueryModel[] = [
  {
    id: MChatPerguntaEnum.PERGUNTA_14_02,
    pergunta: MChatPerguntaEnum.PERGUNTA_14_02,
    textoPergunta: 'Quando ele precisa de alguma coisa?',
  },
  {
    id: MChatPerguntaEnum.PERGUNTA_14_03,
    pergunta: MChatPerguntaEnum.PERGUNTA_14_03,
    textoPergunta: 'Quando você está brincando com ele?',
  },
  {
    id: MChatPerguntaEnum.PERGUNTA_14_04,
    pergunta: MChatPerguntaEnum.PERGUNTA_14_04,
    textoPergunta: 'Durante as alimentações?',
  },
  {
    id: MChatPerguntaEnum.PERGUNTA_14_05,
    pergunta: MChatPerguntaEnum.PERGUNTA_14_05,
    textoPergunta: 'Durante a troca das fraldas?',
  },
  {
    id: MChatPerguntaEnum.PERGUNTA_14_06,
    pergunta: MChatPerguntaEnum.PERGUNTA_14_06,
    textoPergunta: 'Quando você está lendo uma história para ele?',
  },
  {
    id: MChatPerguntaEnum.PERGUNTA_14_07,
    pergunta: MChatPerguntaEnum.PERGUNTA_14_07,
    textoPergunta: 'Quando você está falando com ele?',
  },
]
